// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__nqBu4","main":"Layout_main__FV28D","footer":"Layout_footer__OFT90"};